import StepFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepFileRepositoryFlow';
import StepSignaturePosition from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePosition';
import {
  mapApprovalActions, mapApprovalSteps
} from '@/febos/chile/approvals/wizardFlow/config/wizard/forms/approvalsCommons';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepFlow
    },
    {
      title: 'Ubicar firmas del documento',
      component: StepSignaturePosition,
      condition: (input) => input.setSignaturePosition,
      isLazy: true,
      draftOnBack: true
    }
  ],
  displayNextTitle: true,
  options: ['submit'],
  submitAction: 'sendToFlowRepositoryMassive',
  loadAllData: false,
  wizardMapper(rawData) {
    debugger;
    return {
      documentType: rawData.codeType || rawData.codType || '',
      fileUrl: rawData.urlDescarga,
      filePath: rawData.adjuntoUrl,
      fileIdFlow: rawData.archivoId,
      fileName: rawData.nombre,
      number: rawData.numero,
      type: 'file',
      fileMime: rawData.mime
    };
  },
  documentMapper(input) {
    const data = {
      tipo: input.tipo,
      adjuntos: [],
      aprobacionId: input.flowId,
      ejecucion: {
        privado: input.private ? 'Y' : 'N',
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        unidad: input.documentGroup,
        reversible: true,
        tipoObjetoCategoria: input.documentType,
        tipoDocumentoId: input.documentTypeId,
        tipoReferencia: 'ARCHIVO',
        aprobacionesReferenciaId: input.flowId,
        ...(input.number && { numeroReferencia: input.number }),
        firmaPosicionada: input.setSignaturePosition ? 'Y' : 'N',
        plantilla: {
          aprobaciones: {
            nombre: input.name,
            descripcion: input.description,
            estampar: input.pdfStamp,
            reversible: true,
            foliacion: true,
            tipoejecucion: 'N',
            tipoObjeto: input.typeFlowId,
          },
          ...mapApprovalSteps(input),
        }
      },
      documentos: [
        {
          adjuntoId: input.fileIdFlow,
          adjuntoMime: input.fileMime,
          adjuntoNombre: input.fileName,
          adjuntoUrl: input.fileUrl,
          fecha: input.fileDate,
          objetoId: input.fileId,
          objetoNombre: input.fileName,
          tipoObjetoId: input.typeFlowId,
          tipoObjetoTexto: input.typeFlowText
        }
      ],
      files: input.files?.split(',') || null,
      repositorioId: input.repositoryId,
      carpetaId: input.folderId,
      propietario: input.ownerId,
      filesType: input.tipo,
      gatillacionesPreDefinidas: [
        'a5d53649-e45e-4bd8-8f8b-c1d06b18e9g1',
        'a5d53649-e45e-4bd8-8f8b-c1d06b18e9g2',
        'a5d53649-e45e-4bd8-8f8b-c1d06b18e9g4'
      ],
      ...mapApprovalActions(input)
    };
    if (input.attachments.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.attachments || []).map((file) => ({
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          adjuntoId: file.id,
          adjuntoEstado: 2,
          fecha: file.date,
          adjuntoUrl: file.path
        }))
      ];
    }
    if (input.author) {
      data.meta = {
        author: input.author?.value
      };
    }

    return data;
  }
});
